import { atom, useSetAtom } from 'jotai';
import { useCallback } from 'react';

/** Current step (zero-indexed) for the two-step KPI field form. */
export const kpiFieldFormStepState = atom<number>(0);

export function useResetKpiFieldFormState() {
  const setCurrentStep = useSetAtom(kpiFieldFormStepState);

  return useCallback(() => {
    setCurrentStep(0);
  }, [setCurrentStep]);
}
